import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ name, className, ...props }) => {
  const IconComponent = FiIcons[`Fi${name}`];
  
  if (!IconComponent) {
    return <FiAlertTriangle className={className} {...props} />;
  }

  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;